import React, { useState, useEffect } from 'react'
import { Container, CssBaseline, CircularProgress, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(15),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	}
}))

const Loading = (props) => {
	const classes = useStyles()
	const [progress, setProgress] = useState(0)

	useEffect(() => {
		const tick = () => {
			// reset when reaching 100%
			setProgress((oldProgress) => (oldProgress >= 100 ? 0 : oldProgress + 1))
		}

		const timer = setInterval(tick, 20)
		return () => {
			clearInterval(timer)
		}
	}, [])

	return (
		<Container component="main" maxWidth="xs">
			<CssBaseline />
			<div className={classes.paper}>
				<CircularProgress variant="determinate" size="5rem" value={progress} />
			</div>
		</Container>
	)
}

export default Loading
